import React, { useEffect, useRef, useState } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { motion } from "framer-motion";
import {
  Grid,
  Button,
  Select,
  Dialog,
  Checkbox,
  MenuItem,
  TextField,
  InputLabel,
  DialogTitle,
  FormControl,
  DialogActions,
  DialogContent,
  FormControlLabel,
  CircularProgress,
  DialogContentText,
} from "@mui/material";
import { Editor } from "react-draft-wysiwyg";
import {
  EditorState,
  ContentState,
  convertToRaw,
  convertFromHTML,
  convertFromRaw,
} from "draft-js";
import { toast } from "react-toastify";
import draftToHtml from "draftjs-to-html";
import DeleteIcon from "@mui/icons-material/Delete";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import axiosInterceptorInstance from "../../../utils/axios.interceptor";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";

const ThaOperatorCms = () => {
  const faqFormRef = useRef<HTMLDivElement | null>(null);
  const [rowData, setRowData] = useState<any>([]);

  const [operator, setOperator] = useState<any>("0");
  const [section, setSection] = useState<Number>(0);
  const [title, setTitle] = useState<string>("");
  const [shortCode, setShortCode] = useState<string>("");
  const [display_description, setDisplayDescription] = useState<string>("");
  const [submitRequest, setSubmitRequest] = useState<boolean>(false);
  const [country, setCountry] = useState<any>("0");
  const [product, setProduct] = useState<any>("0");
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [Open, setOpen] = useState<boolean>(false);
  const [circular, setCircular] = useState<boolean>(true);
  const [about, setAbout] = useState<any>([]);
  const [countryListN, setCountryListN] = useState<any[]>([]);
  const [preview, setPreview] = useState<boolean>(false);
  const [faqs, setFaqs] = useState<any>([]);
  const [edit_faqs, setEditFaqs] = useState<any>([]);
  const [delete_faq, setDeleteFaq] = useState<any>([]);
  const [isCheck, setIsCheck] = useState<boolean>(false);
  const [deleteCheck, setDeleteCheck] = useState<boolean>(false);
  const [action, setAction] = useState<boolean>(false);
  const [activeLang, setActiveLang] = useState<string>("en");
  const [activeAboutLang, setActiveAboutLang] = useState<string>("en");
  const [isTranslateFaq, setIsTranslateFaq] = useState<boolean>(false);
  const [isTranslateAbout, setIsTranslateAbout] = useState<boolean>(false);
  const [circle, setCircle] = useState<boolean>(false);

  const languages = ["en", "fr", "es", "it", "de", "ar"];

  const initializeFaqData = () =>
    languages.reduce((data: any, language) => {
      data[language] = {
        question: "",
        answer: "",
        isRedeem: false,
        editorState: EditorState.createEmpty(),
      };
      return data;
    }, {});

  const [faqData, setFaqData] = useState<any>(initializeFaqData);

  const initializeAboutData = () =>
    languages.reduce((data: any, language) => {
      data[language] = {
        customPageTitle: "",
        excerpt: "",
        description: "",
        editorState: EditorState.createEmpty(),
      };
      return data;
    }, {});

  const [aboutData, setAboutData] = useState<any>(initializeAboutData);

  const loadCountries = async () => {
    await fetch("/data/thacountry.json")
      .then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error " + response.status);
        }
        return response.json();
      })
      .then((json: any) => {
        setCountryListN(json.thacountries);
      });
  };

  const controller = new AbortController();

  useEffect(() => {
    loadCountries();
    return () => {
      controller.abort();
    };
  }, []);

  useEffect(() => {
    if (country == "0" || country == undefined || product == "0") {
      setIsOpen(false);
      setOpen(false);
      setCircular(false);
      setCircle(false);
    } else {
      setRowData([]);
      getOperator();
      setSection(0);
      setIsOpen(true);
      setCircular(true);
      setOperator(0);
      setFaqs([]);
    }
  }, [country, product]);

  useEffect(() => {
    setCircle(false);
    if (operator != "0" && operator != undefined && section == 1) {
      getDescription(operator);
    }
    if (section == 1 && (operator == "0" || operator == undefined)) {
      getDescriptionByCountry();
    }
    if (operator != "0" && operator != undefined && section == 2) {
      getFAQ();
    }
    if (section == 2 && (operator == "0" || operator == undefined)) {
      getFAQByCountry();
    }
  }, [operator, section]);

  useEffect(() => {
    updateEditorAndDisplayFaq();
  }, [edit_faqs]);

  useEffect(() => {
    if (operator == "0" || operator == undefined) {
      setOpen(false);
    } else {
      setOpen(true);
      setShortCode(operator?.operatorShortCode || "");
      setTitle(operator?.operatorName || "");
    }
  }, [operator]);
  useEffect(() => {
    if (section == 0) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }, [section]);

  useEffect(() => {
    const updatedAboutData = initializeAboutData();
    const details = Array.isArray(about.payload) ? about.payload : [];

    details.forEach((detail: any) => {
      const language = detail.languageCode?.toLowerCase();
      if (!languages.includes(language)) return;

      const blocksFromHTML = convertFromHTML(detail.description || "");
      const contentState = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap,
      );
      updatedAboutData[language] = {
        customPageTitle: detail.customPageTitle || "",
        excerpt: detail.excerpt || "",
        description: detail.description || "",
        editorState: EditorState.createWithContent(contentState),
      };
    });

    setAboutData(updatedAboutData);
  }, [about]);

  useEffect(() => {
    const activeAbout = aboutData[activeAboutLang];
    setDisplayDescription(activeAbout?.description || "");
  }, [aboutData, activeAboutLang]);
  const updateEditorAndDisplayFaq = () => {
    if (!Array.isArray(edit_faqs) || edit_faqs.length === 0) return;

    const updatedFaqData = initializeFaqData();
    languages.forEach((language) => {
      const matchingFaq = edit_faqs.find(
        (faq: any) => (faq.languageCode || faq.language) === language,
      );

      if (matchingFaq) {
        const blocksFromHTML = convertFromHTML(matchingFaq.answer || "");
        const contentState = ContentState.createFromBlockArray(
          blocksFromHTML.contentBlocks,
          blocksFromHTML.entityMap,
        );
        updatedFaqData[language] = {
          question: matchingFaq.question || "",
          answer: matchingFaq.answer || "",
          isRedeem: matchingFaq.isRedeem || false,
          editorState: EditorState.createWithContent(contentState),
        };
      }
    });
    setFaqData(updatedFaqData);
  };

  const updateEditorAndDisplay = (newEditorState: EditorState) => {
    const value = draftToHtml(convertToRaw(newEditorState.getCurrentContent()));
    setFaqData((previous: any) => ({
      ...previous,
      [activeLang]: {
        ...previous[activeLang],
        answer: value,
        editorState: newEditorState,
      },
    }));
  };

  const onEditorFaqChange = (newEditorState: EditorState) => {
    updateEditorAndDisplay(newEditorState);
  };

  const updateDescription = (newEditorState: EditorState) => {
    // Get the content as raw data
    const contentState = newEditorState.getCurrentContent();
    const isEmpty =
      !contentState.hasText() || contentState.getPlainText().trim() === "";

    // Conditionally set the value
    const value = isEmpty ? "" : draftToHtml(convertToRaw(contentState));
    setDisplayDescription(value);
    setAboutData((previous: any) => ({
      ...previous,
      [activeAboutLang]: {
        ...previous[activeAboutLang],
        description: value,
        editorState: newEditorState,
      },
    }));
  };

  const onEditorStateChange = (newEditorState: EditorState) => {
    updateDescription(newEditorState);
  };

  const handleTranslateAbout = async () => {
    toast.dismiss();
    const source = aboutData[activeAboutLang];
    const plainDescription = source?.editorState
      ?.getCurrentContent()
      .getPlainText()
      .trim();

    if (
      !plainDescription ||
      plainDescription.length < 3 ||
      !source?.excerpt?.trim() ||
      !source?.customPageTitle?.trim()
    ) {
      toast.warn(
        "Enter a description, excerpt, and custom page title in the current tab first.",
      );
      return;
    }

    if (activeAboutLang === "en-gb") {
      toast.warn("Please translate from EN or another language tab.");
      return;
    }

    setIsTranslateAbout(true);
    const rawDescription = convertToRaw(source.editorState.getCurrentContent());
    const descriptionHtml = draftToHtml(rawDescription);
    const targetLanguages = languages.filter(
      (language) => language !== activeAboutLang && language !== "en-gb",
    );

    try {
      const response = await axiosInterceptorInstance.post(
        "/Translate/TextTraslate",
        {
          text: [descriptionHtml, source.excerpt, source.customPageTitle],
          sourceLang: activeAboutLang,
          targetLang: targetLanguages,
          format: "html",
        },
      );
      const results = response?.data?.translateResult || [];

      if (!results.length) {
        toast.error("Translation failed.");
        return;
      }

      const translatedAboutData = { ...aboutData };
      results.forEach((item: any) => {
        const language = item.targetedlanguage?.toLowerCase();
        if (!languages.includes(language)) return;

        const translatedDescription = item.translatedText?.[0] || "";
        const blocksFromHTML = convertFromHTML(translatedDescription);
        const contentState = ContentState.createFromBlockArray(
          blocksFromHTML.contentBlocks,
          blocksFromHTML.entityMap,
        );
        translatedAboutData[language] = {
          description: translatedDescription,
          excerpt: item.translatedText?.[1] || "",
          customPageTitle: item.translatedText?.[2] || "",
          editorState: EditorState.createWithContent(contentState),
        };

        if (language === "en") {
          translatedAboutData["en-gb"] = translatedAboutData.en;
        }
      });

      translatedAboutData[activeAboutLang] = {
        ...source,
        description: descriptionHtml,
        editorState: EditorState.createWithContent(
          convertFromRaw(rawDescription),
        ),
      };
      if (activeAboutLang === "en") {
        translatedAboutData["en-gb"] = translatedAboutData.en;
      }

      setAboutData(translatedAboutData);
      toast.success("About translation applied successfully.");
    } catch (error) {
      console.error("About translation API error:", error);
      toast.error("An error occurred during About translation.");
    } finally {
      setIsTranslateAbout(false);
    }
  };

  const getOperator = async () => {
    toast.dismiss();
    await axiosInterceptorInstance
      .post(
        `/FusionHubCrm/GetOperators`,
        {
          page: 1,
          recordsPerPage: 999,
          operatorFilters: {
            countryIsoCode: country.isoCode2,
            currencyCode: "USD",
            categoryAliasName: product,
          },
        },
        { signal: controller.signal },
      )
      .then((response: any) => {
        const responseData = response?.data.payload;
        let finalData: any[] = [];
        responseData.forEach((item: any) => {
          finalData.push(item.operator);
        });
        if (finalData.length == 0) {
          toast.error("No Record Found");
          setCircular(false);
        } else {
          setRowData(finalData);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleSave = async () => {
    const isOperatorValid = operator !== 0 && operator !== undefined;
    const isSectionOne = section == 1;
    const isSectionTwo = section == 2;

    if (isSectionOne) {
      // Section 1 logic
      if (isOperatorValid && title !== "" && shortCode !== "") {
        AddDescription();
      } else if (!isOperatorValid) {
        AddDescriptionByCountry(); // Allow saving without operator checks
      } else {
        toast.error("Please enter the required inputs.");
      }
    } else if (isSectionTwo) {
      // Section 2 logic
      if (isOperatorValid && title !== "" && shortCode !== "") {
        CheckFaqAndDescription();
      } else if (!isOperatorValid) {
        CheckFaqAndDescriptionByCountry(); // Allow saving without operator checks
      } else {
        toast.error("Please enter the required inputs.");
      }
    } else {
      // Neither section is selected
      toast.error("Please select a valid section.");
    }
  };

  const AddDescription = async () => {
    setSubmitRequest(true);
    const existingDetail = Array.isArray(about.payload)
      ? about.payload[0]
      : null;

    await axiosInterceptorInstance
      .post(`/ThaCrm/addabout`, {
        operatorDetailDataId: existingDetail?.operatorDetailDataId || 0,
        name: operator?.operatorName || existingDetail?.name || "",
        customName: existingDetail?.customName || "",
        operatorShortCode: operator?.operatorShortCode || "",
        logo: operator?.logo || existingDetail?.logo || "",
        subcategoryShortCode: existingDetail?.subcategoryShortCode || "",
        categoryShortCode: product,
        popularityRank: existingDetail?.popularityRank || 0,
        countryIsoCode: country.isoCode2,
        data: languages.map((language) => ({
          languageCode: language,
          description: aboutData[language]?.description || "",
          excerpt: aboutData[language]?.excerpt || "",
          customPageTitle: aboutData[language]?.customPageTitle || "",
        })),
      })
      .then((res: any) => {
        const data = res.data;
        toast.success(data.message);
      })
      .catch((error: any) => {
        setSubmitRequest(false);
      })
      .finally(() => {
        setSubmitRequest(false);
      });
  };
  const AddDescriptionByCountry = async () => {
    setSubmitRequest(true);
    const existingDetail = Array.isArray(about.payload)
      ? about.payload[0]
      : null;

    await axiosInterceptorInstance
      .post(`/ThaCrm/addaboutbycountry`, {
        countryDetailDataId: existingDetail?.countryDetailDataId || 0,
        logo: country.countryLogo || existingDetail?.logo || "",
        customName: existingDetail?.customName || country.countryName || "",
        name: country.countryName || existingDetail?.name || "",
        popularityRank: existingDetail?.popularityRank || 0,
        isActive: true,
        countryIsoCode: country.isoCode2,
        data: languages.map((language) => ({
          languageCode: language,
          description: aboutData[language]?.description || "",
          excerpt: aboutData[language]?.excerpt || "",
          customPageTitle: aboutData[language]?.customPageTitle || "",
        })),
      })
      .then((res: any) => {
        const data = res.data;
        toast.success(data.message);
      })
      .catch((error: any) => {
        setSubmitRequest(false);
      })
      .finally(() => {
        setSubmitRequest(false);
      });
  };

  const getDescription = async (operator: any) => {
    try {
      const response = await axiosInterceptorInstance.get(
        `/ThaCrm/getabout?operatorShortCode=${
          operator?.operatorShortCode ? operator?.operatorShortCode : null
        }&countryIsoCode=${country.isoCode2}`,
      );
      const responseData = response.data;
      setAbout(responseData);
      toast.info(responseData.message);
    } catch (error) {
      console.error(error);
    }
  };
  const getDescriptionByCountry = async () => {
    try {
      const response = await axiosInterceptorInstance.get(
        `/ThaCrm/getaboutbycountry?countryIsoCode=${country.isoCode2}`,
      );
      const responseData = response.data;
      setAbout(responseData);
      toast.info(responseData.message);
    } catch (error) {
      console.error(error);
    }
  };

  const getFAQ = async () => {
    setCircle(true);
    await axiosInterceptorInstance
      .get(
        `/ThaCrm/getfaq?operatorShortCode=${
          operator?.operatorShortCode ? operator?.operatorShortCode : null
        }&countryIsoCode=${country.isoCode2}`,
      )
      .then((response) => {
        setCircle(false);
        const responseData = response?.data;
        toast.info(responseData.message);
        if (responseData.payload) {
          setFaqs(responseData.payload);
        } else {
          setFaqs([]);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const getFAQByCountry = async () => {
    setCircle(true);
    await axiosInterceptorInstance
      .get(`/ThaCrm/GetFaqByCountry?countryIsoCode=${country.isoCode2}`)
      .then((response) => {
        setCircle(false);
        const responseData = response?.data;
        toast.info(responseData.message);
        if (responseData.payload) {
          setFaqs(responseData.payload);
        } else {
          setFaqs([]);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const AddFaq = async () => {
    setSubmitRequest(true);
    const editedFaq = Array.isArray(edit_faqs) ? edit_faqs[0] : null;
    await axiosInterceptorInstance
      .post(`/ThaCrm/upsertfaq`, {
        ...(isCheck && editedFaq?.operatorFaqId
          ? { faqId: editedFaq.operatorFaqId }
          : {}),
        translations: languages.map((language) => ({
          question: faqData[language]?.question || "",
          answer: faqData[language]?.answer || "",
          languageCode: language,
          isRedeem: faqData[language]?.isRedeem || false,
        })),
        operatorName: operator?.operatorName ? operator?.operatorName : null,
        operatorShortCode: operator?.operatorShortCode
          ? operator?.operatorShortCode
          : null,
        countryIsoCode: country.isoCode2,
      })
      .then((res: any) => {
        const data = res.data;
        toast.success(data.message);
        getFAQ();
        ClearFaq();
      })
      .catch((error: any) => {
        setSubmitRequest(false);
      })
      .finally(() => {
        setSubmitRequest(false);
      });
  };
  const AddFaqByCountry = async () => {
    setSubmitRequest(true);
    const editedFaq = Array.isArray(edit_faqs) ? edit_faqs[0] : null;
    await axiosInterceptorInstance
      .post(`/ThaCrm/upsertfaqbycountry`, {
        ...(isCheck && editedFaq?.countryFaqId
          ? { faqId: editedFaq.countryFaqId }
          : {}),
        translations: languages.map((language) => ({
          question: faqData[language]?.question || "",
          answer: faqData[language]?.answer || "",
          languageCode: language,
          isRedeem: faqData[language]?.isRedeem || false,
        })),
        CountryName: country.countryName,
        countryIsoCode: country.isoCode2,
      })
      .then((res: any) => {
        const data = res.data;
        toast.success(data.message);
        getFAQByCountry();
        ClearFaq();
      })
      .catch((error: any) => {
        setSubmitRequest(false);
      })
      .finally(() => {
        setSubmitRequest(false);
      });
  };
  const deleteFAQ = async () => {
    setAction(true);
    const deleteUrl = delete_faq.countryFaqMultilingualId
      ? `/ThaCrm/deletefaqbycountry?countryFaqMultilingualId=${delete_faq.countryFaqMultilingualId}`
      : `/ThaCrm/deletefaq?operatorFaqMultilingualId=${delete_faq.operatorFaqMultilingualId}`;

    await axiosInterceptorInstance
      .delete(deleteUrl)
      .then((res: any) => {
        const data = res.data;
        setDeleteCheck(false);
        setAction(false);
        CheckDeletionAndGetFaq();
        toast.success(data.message);
      })
      .catch((error: any) => {
        setAction(false);
        setDeleteCheck(false);
      });
  };

  const ClearFaq = () => {
    setIsCheck(false);
    setEditFaqs([]);
    setFaqData(initializeFaqData());
  };
  const CheckFaqAndDescription = () => {
    const isValid = languages.every(
      (language) =>
        faqData[language]?.question.trim() && faqData[language]?.answer.trim(),
    );
    if (isValid) {
      AddFaq();
    } else {
      toast.error("Please enter a question and answer in every language tab.");
    }
  };
  const CheckFaqAndDescriptionByCountry = () => {
    const isValid = languages.every(
      (language) =>
        faqData[language]?.question.trim() && faqData[language]?.answer.trim(),
    );
    if (isValid) {
      AddFaqByCountry();
    } else {
      toast.error("Please enter a question and answer in every language tab.");
    }
  };
  const handleTranslate = async () => {
    toast.dismiss();
    const source = faqData[activeLang];

    if (
      !source?.question?.trim() ||
      !source?.answer?.trim() ||
      !source?.editorState
    ) {
      toast.warn("Enter a question and answer in the current tab first.");
      return;
    }

    if (activeLang === "en-gb") {
      toast.warn("Please translate from EN or another language tab.");
      return;
    }

    setIsTranslateFaq(true);
    const rawAnswer = convertToRaw(source.editorState.getCurrentContent());
    const answerHtml = draftToHtml(rawAnswer);
    const targetLanguages = languages.filter(
      (language) => language !== activeLang && language !== "en-gb",
    );

    try {
      const response = await axiosInterceptorInstance.post(
        "/Translate/TextTraslate",
        {
          text: [answerHtml, source.question],
          sourceLang: activeLang,
          targetLang: targetLanguages,
          format: "html",
        },
      );
      const results = response?.data?.translateResult || [];

      if (!results.length) {
        toast.error("Translation failed.");
        return;
      }

      const translatedFaqData = { ...faqData };
      results.forEach((item: any) => {
        const language = item.targetedlanguage;
        const translatedAnswer = item.translatedText?.[0] || "";
        const translatedQuestion = item.translatedText?.[1] || "";
        const blocksFromHTML = convertFromHTML(translatedAnswer);
        const contentState = ContentState.createFromBlockArray(
          blocksFromHTML.contentBlocks,
          blocksFromHTML.entityMap,
        );
        translatedFaqData[language] = {
          question: translatedQuestion,
          answer: translatedAnswer,
          isRedeem: source.isRedeem,
          editorState: EditorState.createWithContent(contentState),
        };

        if (language === "en") {
          translatedFaqData["en-gb"] = translatedFaqData[language];
        }
      });

      translatedFaqData[activeLang] = {
        ...source,
        answer: answerHtml,
        editorState: EditorState.createWithContent(convertFromRaw(rawAnswer)),
      };
      if (activeLang === "en") {
        translatedFaqData["en-gb"] = translatedFaqData.en;
      }

      setFaqData(translatedFaqData);
      toast.success("Translation applied successfully.");
    } catch (error) {
      console.error("Translation API error:", error);
      toast.error("An error occurred during translation.");
    } finally {
      setIsTranslateFaq(false);
    }
  };
  const CheckDeletionAndGetFaq = () => {
    const isOperatorValid = operator !== 0 && operator !== undefined;
    // Section 2 logic
    if (!isOperatorValid) {
      getFAQByCountry();
    } else {
      getFAQ();
    }
  };
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div className="boxShadow">
        <h2 className="sectionTitle">Operator CMS</h2>
        <div className="boxInner">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <fieldset>
                <legend>General Information:</legend>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    {countryListN && (
                      <FormControl style={{ width: "100%" }}>
                        <InputLabel
                          id="demo-simple-select-label"
                          style={{ background: "#fff", padding: " 0 5px" }}
                        >
                          Countries
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          className="formControl"
                          autoWidth
                          value={country?.isoCode2 || "0"}
                          defaultValue={country?.isoCode2 || "0"}
                          onChange={(e: any) => {
                            ClearFaq();
                            const country = countryListN?.find(
                              (item) => item.isoCode2 === e.target.value,
                            );
                            setCountry(country);
                          }}
                        >
                          <MenuItem value="0">Select Country</MenuItem>
                          {countryListN.map((item, index) => (
                            <MenuItem key={index} value={item?.isoCode2}>
                              {item?.countryName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  </Grid>

                  <Grid item xs={6}>
                    <FormControl style={{ width: "100%" }}>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ background: "#fff", padding: " 0 5px" }}
                      >
                        Product Type
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        className="formControl"
                        autoWidth
                        value={product}
                        defaultValue={product}
                        onChange={(e: any) => {
                          setProduct(e.target.value);
                        }}
                      >
                        <MenuItem value="0">Choose Type</MenuItem>
                        <MenuItem value="gift_cards"> Gift Card </MenuItem>
                        <MenuItem value="mobile">Mobile</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </fieldset>
            </Grid>
            {circular == true && rowData.length == 0 && (
              <div className="circular-loader">
                <CircularProgress size={40} />
              </div>
            )}
            {isOpen && rowData.length > 0 && (
              <Grid item xs={12}>
                <fieldset>
                  <legend>Operator Selection:</legend>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <FormControl style={{ width: "100%" }}>
                        <InputLabel
                          id="demo-simple-select-label"
                          style={{ background: "#fff", padding: " 0 5px" }}
                        >
                          Operator
                        </InputLabel>

                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          className="formControl"
                          autoWidth
                          value={operator?.operatorId || "0"}
                          defaultValue={operator?.operatorId || "0"}
                          onChange={(e: any) => {
                            const operator = rowData?.find(
                              (item: any) => item.operatorId === e.target.value,
                            );

                            ClearFaq();
                            setOperator(operator);
                          }}
                        >
                          <MenuItem value="0">Choose Type</MenuItem>

                          {rowData?.map((item: any, index: any) => (
                            <MenuItem key={index} value={item?.operatorId}>
                              {item?.operatorName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={6}>
                      <FormControl style={{ width: "100%" }}>
                        <InputLabel
                          id="demo-simple-select-label"
                          style={{ background: "#fff", padding: " 0 5px" }}
                        >
                          Section
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          className="formControl"
                          autoWidth
                          value={section}
                          defaultValue={section}
                          onChange={(e: any) => {
                            setSection(e.target.value);
                          }}
                        >
                          <MenuItem value="0">Choose Type</MenuItem>
                          <MenuItem value="1"> About</MenuItem>
                          <MenuItem value="2">FAQ</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </fieldset>
              </Grid>
            )}
            {section != 0 &&
              Open &&
              operator != "0" &&
              operator != undefined && (
                <Grid item xs={12}>
                  <fieldset>
                    <legend>Operator Information:</legend>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <TextField
                          className="formControl"
                          label="Title"
                          variant="outlined"
                          value={title}
                          inputProps={{ maxLength: 200 }}
                          onChange={(e: any) => {
                            setTitle(e.target.value);
                          }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          className="formControl"
                          label="Short Code"
                          variant="outlined"
                          value={shortCode}
                          inputProps={{ maxLength: 200, readOnly: true }}
                          onChange={(e: any) => {
                            setShortCode(e.target.value);
                          }}
                        />
                      </Grid>
                    </Grid>
                  </fieldset>
                </Grid>
              )}

            {section == 1 &&
              country != undefined &&
              country != "0" &&
              product != "0" && (
                <Grid item xs={12} className="languageHeader">
                  <div
                    className="languageHeader"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 10,
                    }}
                  >
                    <div>
                      {languages.map((language) => (
                        <button
                          key={language}
                          type="button"
                          className="multiLanTabs"
                          onClick={() => setActiveAboutLang(language)}
                          style={{
                            backgroundColor:
                              activeAboutLang === language ? "#1976d2" : "#eee",
                            color:
                              activeAboutLang === language ? "#fff" : "#000",
                          }}
                        >
                          {language.toUpperCase()}
                        </button>
                      ))}
                    </div>
                    <Button
                      className="dButton multilanFaqTranslate"
                      variant="contained"
                      onClick={handleTranslateAbout}
                      disabled={isTranslateAbout}
                    >
                      {isTranslateAbout ? (
                        <CircularProgress color="inherit" size={30} />
                      ) : (
                        "Translate"
                      )}
                    </Button>
                  </div>
                  <h2>About Editor ({activeAboutLang.toUpperCase()})</h2>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        className="formControl"
                        label="CustomPageTitle"
                        variant="outlined"
                        value={
                          aboutData[activeAboutLang]?.customPageTitle || ""
                        }
                        multiline={true}
                        rows={3}
                        onChange={(e: any) => {
                          setAboutData((previous: any) => ({
                            ...previous,
                            [activeAboutLang]: {
                              ...previous[activeAboutLang],
                              customPageTitle: e.target.value,
                            },
                          }));
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        className="formControl"
                        label="EXCERPT"
                        variant="outlined"
                        value={aboutData[activeAboutLang]?.excerpt || ""}
                        multiline={true}
                        rows={3}
                        onChange={(e: any) => {
                          setAboutData((previous: any) => ({
                            ...previous,
                            [activeAboutLang]: {
                              ...previous[activeAboutLang],
                              excerpt: e.target.value,
                            },
                          }));
                        }}
                      />
                    </Grid>
                  </Grid>

                  <div className="boxShadow editor">
                    <Editor
                      editorState={aboutData[activeAboutLang]?.editorState}
                      toolbarClassName="toolbarClassName"
                      wrapperClassName="wrapperClassName"
                      editorClassName="editorScrollable"
                      onEditorStateChange={onEditorStateChange}
                    />
                  </div>
                </Grid>
              )}

            {section == 2 &&
              country != undefined &&
              country != "0" &&
              product != "0" && (
                <Grid item xs={12} className="languageHeader">
                  <div
                    style={{
                      display: "flex",
                      marginBottom: 10,
                      justifyContent: "space-between",
                    }}
                  >
                    <div>
                      {languages.map((language) => (
                        <button
                          key={language}
                          type="button"
                          className="multiLanTabs"
                          onClick={() => setActiveLang(language)}
                          style={{
                            backgroundColor:
                              activeLang === language ? "#1976d2" : "#eee",
                            color: activeLang === language ? "#fff" : "#000",
                          }}
                        >
                          {language.toUpperCase()}
                        </button>
                      ))}
                    </div>
                    <Button
                      className="dButton multilanFaqTranslate"
                      variant="contained"
                      onClick={handleTranslate}
                      disabled={isTranslateFaq}
                    >
                      {isTranslateFaq ? (
                        <CircularProgress color="inherit" size={30} />
                      ) : (
                        "Translate"
                      )}
                    </Button>
                  </div>
                </Grid>
              )}

            {section == 2 &&
              faqs.length !== 0 &&
              country !== undefined &&
              country !== "0" &&
              product !== "0" &&
              !circle && (
                <div className="faq-list-container">
                  <h2>Frequently Asked Questions</h2>
                  <Grid item xs={12}>
                    {faqs
                      .filter(
                        (faq: any) =>
                          (faq.languageCode || faq.language) === activeLang,
                      )
                      .map((faq: any, index: number) => (
                        <div key={index} className="faq-item">
                          <div className="faq-header">
                            <h3 style={{ padding: "0" }}>
                              Q{faq.operatorFaqId || faq.countryFaqId}:
                              {faq.question}
                            </h3>
                            <div className="faq-header">
                              {faq.isRedeem ? (
                                <p className="Redeem">Redeem</p>
                              ) : null}
                              <DriveFileRenameOutlineOutlinedIcon
                                className="edit-button"
                                style={{ marginRight: "20px" }}
                                onClick={() => {
                                  const faqId =
                                    faq.operatorFaqId || faq.countryFaqId;
                                  const relatedFaqs = faqs.filter(
                                    (item: any) =>
                                      (item.operatorFaqId ||
                                        item.countryFaqId) === faqId,
                                  );
                                  setEditFaqs(relatedFaqs);
                                  setIsCheck(true);
                                  faqFormRef.current?.scrollIntoView({
                                    behavior: "smooth",
                                    block: "start",
                                  });
                                }}
                              ></DriveFileRenameOutlineOutlinedIcon>
                              <DeleteIcon
                                className="edit-button"
                                onClick={() => {
                                  (setDeleteFaq(faq), setDeleteCheck(true));
                                }}
                              ></DeleteIcon>
                            </div>
                          </div>
                          <p dangerouslySetInnerHTML={{ __html: faq.answer }} />
                          <hr />
                        </div>
                      ))}
                  </Grid>
                </div>
              )}
            {circle && (
              <div className="circular-loader">
                <CircularProgress size={40} />
              </div>
            )}
            {section == 2 &&
              country != undefined &&
              country != "0" &&
              product !== "0" && (
                <Grid item xs={12} ref={faqFormRef}>
                  <h2
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    FAQ Section{" "}
                    <Button
                      className="dButton "
                      variant="contained"
                      style={{ width: "10%", height: "35px" }}
                      onClick={() => ClearFaq()}
                    >
                      Clear
                    </Button>
                  </h2>

                  <Grid item xs={12}>
                    <TextField
                      className="formControl"
                      label={`Question for (${activeLang})`}
                      variant="outlined"
                      value={faqData[activeLang]?.question || ""}
                      inputProps={{ maxLength: 200 }}
                      onChange={(e: any) =>
                        setFaqData((previous: any) => ({
                          ...previous,
                          [activeLang]: {
                            ...previous[activeLang],
                            question: e.target.value,
                          },
                        }))
                      }
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControlLabel
                      style={{ marginLeft: "0px" }}
                      control={
                        <Checkbox
                          checked={faqData[activeLang]?.isRedeem || false}
                          onChange={(e: any) =>
                            setFaqData((previous: any) => ({
                              ...previous,
                              [activeLang]: {
                                ...previous[activeLang],
                                isRedeem: e.target.checked,
                              },
                            }))
                          }
                          inputProps={{ "aria-label": "controlled" }}
                          size="medium"
                        />
                      }
                      label="Redeem"
                      labelPlacement="start"
                    />
                  </Grid>
                  <h2>Answer</h2>
                  <div className="boxShadow editor">
                    <Editor
                      editorState={faqData[activeLang]?.editorState}
                      toolbarClassName="toolbarClassName"
                      wrapperClassName="wrapperClassName"
                      editorClassName="editorScrollable"
                      onEditorStateChange={onEditorFaqChange}
                    />
                  </div>
                </Grid>
              )}
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={3} style={{ marginLeft: "30%" }}>
                  {!submitRequest &&
                    country != undefined &&
                    country != "0" &&
                    product !== "0" &&
                    section != 0 && (
                      <Button
                        className="dButton "
                        variant="contained"
                        onClick={() => handleSave()}
                      >
                        Save
                      </Button>
                    )}
                  {submitRequest && (
                    <Button className="dButton " variant="contained">
                      <CircularProgress color="inherit" size={30} />
                    </Button>
                  )}
                </Grid>
                <Grid item xs={3}>
                  {display_description &&
                    country != undefined &&
                    country != "0" &&
                    product !== "0" &&
                    section == 1 && (
                      <Button
                        className="dButton "
                        variant="contained"
                        onClick={() => setPreview(true)}
                      >
                        Preview
                      </Button>
                    )}
                </Grid>
              </Grid>
            </Grid>

            <Dialog
              className="operator-preview"
              open={preview}
              onClose={() => setPreview(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <div dangerouslySetInnerHTML={{ __html: display_description }} />
            </Dialog>

            <Dialog
              open={deleteCheck}
              onClose={() => setDeleteCheck(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"Delete FAQ Confirmation"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Would you really like to delete this FAQ?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="contained"
                  className="dButton dButton2 dbuttonSec"
                  onClick={() => setDeleteCheck(false)}
                >
                  No
                </Button>
                <div style={{ width: "30px" }}></div>
                {!action && (
                  <Button
                    variant="contained"
                    className="dButton dButton2"
                    onClick={() => {
                      deleteFAQ();
                    }}
                    autoFocus
                  >
                    Yes
                  </Button>
                )}
                {action && (
                  <Button className="dButton dButton2" variant="contained">
                    <CircularProgress color="inherit" size={30} />
                  </Button>
                )}
              </DialogActions>
            </Dialog>
          </Grid>
        </div>
      </div>
    </motion.div>
  );
};

export default ThaOperatorCms;
